import isTouch from '../helpers/isTouch';
function cursorLogic(){
    if (!isTouch()){
        setTimeout(() => {
            const cursor = document.querySelector('.cursor');
            const customWrappers = document.querySelectorAll('.custom-cursor');

            customWrappers.forEach(wrapper =>{
                wrapper.addEventListener('mouseenter', () => {
                    if(wrapper.dataset.cursorPopap != "true"){
                        cursor.innerHTML = wrapper.dataset.cursor;
                        cursor.classList.add('hovered');
                        cursor.innerHTML = wrapper.dataset.cursor;
                    } else {
                        cursor.classList.add('cursor-closed');
                        cursor.classList.remove('hovered');
                    }
                })
                wrapper.addEventListener('mouseleave', () =>  {
                    const openedPopup = document.querySelector('.popup.open')
                    if (openedPopup) {return}
                    cursor.classList.remove('hovered');
                    cursor.classList.remove('cursor-closed');
                });
                wrapper.querySelectorAll('a, button, canvas').forEach(link =>{
                    
                    link.addEventListener('mouseenter', () => {
                        
                        cursor.classList.remove('hovered');
                        
                        if (link.tagName == 'CANVAS'){cursor.classList.remove('cursor-closed')}
                    })
                    link.addEventListener('mouseleave', () => {
                        cursor.classList.add('hovered');
                        if (link.tagName == 'CANVAS'){cursor.classList.add('cursor-closed')}
                    } );
                })
            })
        }, 10);
        const cursor = document.querySelector('.cursor');
        const customWrappers = document.querySelectorAll('.custom-cursor');

        customWrappers.forEach(wrapper =>{
            wrapper.addEventListener('mouseenter', () => {
                cursor.classList.add('hovered');
                cursor.innerHTML = wrapper.dataset.cursor;
                wrapper.querySelectorAll('a, button, canvas').forEach(link =>{
                    link.addEventListener('mouseenter', () => {
                        cursor.classList.remove('hovered');
                    })
                    link.addEventListener('mouseleave', () =>  cursor.classList.add('hovered'));
                })
            })
            wrapper.addEventListener('mouseleave', () =>  cursor.classList.remove('hovered'));
            
        })
   
       

        document.addEventListener('mousemove', (e) => {
            cursorPos(e, cursor);
        });
        document.addEventListener('click', (e) => {
            cursorPos(e, cursor);
        });

        document.addEventListener("click", (e) => {
            setTimeout(()=>{
                cursor.classList.remove('click')
            },500)
        });

        function cursorPos(e, cursor){
            let cursorHalfWidth = cursor.offsetWidth/2;
            cursor.setAttribute("style","top: "+(e.clientY-cursorHalfWidth)+"px; left: "+ (e.clientX-cursorHalfWidth) +"px;");
        }
    }

}

export {
    cursorLogic,
};